import { IState } from "@/redux/store.types";
import { getValueState } from "@/redux/utils";

import { $StickyActionsModuleName } from "./stickyActions.types";

const isOpen = (state: IState) => {
    return (
        (getValueState(state, $StickyActionsModuleName)?.references ?? 0) > 0
    );
};

export { isOpen };
